import React from 'react'
import { useForm, usePage } from '@inertiajs/inertia-react'
import AlertDismissible from '../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import Layout from '../../Shared/Layout/LayoutAdmin'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import { SIA_NAVY } from '../../constants/siaTheme'

const SecomReports = ({ rows, filters, offices, advisers, statuses }) => {
    const { flash } = usePage().props

    const filterForm = useForm({
        office_id: filters.office_id || '',
        adviser_id: filters.adviser_id || '',
        secom_status_id: filters.secom_status_id || '',
    })

    const submit = (e) => {
        e.preventDefault()
        filterForm.get(route('secom.reports'), { preserveState: true })
    }

    const exportUrl = () => {
        const params = new URLSearchParams()
        if (filterForm.data.office_id) params.set('office_id', filterForm.data.office_id)
        if (filterForm.data.adviser_id) params.set('adviser_id', filterForm.data.adviser_id)
        if (filterForm.data.secom_status_id) params.set('secom_status_id', filterForm.data.secom_status_id)
        const qs = params.toString()
        return route('secom.reports.export') + (qs ? `?${qs}` : '')
    }

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath="admin/secom/reportes" />
            </span>

            <div
                className="rounded-2 mb-8 py-4 px-4 text-center text-white text-uppercase fw-bold fs-4"
                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.04em' }}
            >
                Área de reportes — SECOM
            </div>

            <div className="card card-flush shadow-sm mb-8">
                <div className="card-body py-8 px-6">
                    <Form onSubmit={submit} className="row g-4 align-items-end justify-content-center">
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Oficina</Form.Label>
                            <Form.Select
                                value={filterForm.data.office_id}
                                onChange={(e) => filterForm.setData('office_id', e.target.value)}
                            >
                                <option value="">Seleccione una opción</option>
                                {offices.map((o) => (
                                    <option key={o.id} value={o.id}>
                                        {o.nombre}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Asesor</Form.Label>
                            <Form.Select
                                value={filterForm.data.adviser_id}
                                onChange={(e) => filterForm.setData('adviser_id', e.target.value)}
                            >
                                <option value="">Seleccione una opción</option>
                                {advisers.map((a) => (
                                    <option key={a.id} value={a.id}>
                                        {a.display_name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Status</Form.Label>
                            <Form.Select
                                value={filterForm.data.secom_status_id}
                                onChange={(e) => filterForm.setData('secom_status_id', e.target.value)}
                            >
                                <option value="">Seleccione una opción</option>
                                {statuses.map((s) => (
                                    <option key={s.id} value={s.id}>
                                        {s.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={12} className="text-center pt-2">
                            <Button type="submit" variant="primary" disabled={filterForm.processing}>
                                <i className="bi bi-bar-chart me-2" />
                                Generar reporte
                            </Button>
                        </Col>
                    </Form>
                </div>
            </div>

            <div className="card card-flush shadow-sm">
                <div className="card-header border-0 pt-6 flex-wrap gap-3">
                    <h3 className="card-title fw-bold text-gray-800">Resultados</h3>
                    <div className="card-toolbar">
                        <a href={exportUrl()} className="btn btn-sm btn-success">
                            <i className="bi bi-file-earmark-excel me-1" />
                            Exportar Excel
                        </a>
                    </div>
                </div>
                <div className="card-body pt-0">
                    <Table responsive hover className="align-middle">
                        <thead className="text-gray-600 fw-bold fs-7 text-uppercase">
                            <tr>
                                <th>Oficina</th>
                                <th>Asesor</th>
                                <th className="text-end">Total de pólizas</th>
                                <th className="text-end">Pólizas asignadas</th>
                                <th className="text-end">Pólizas actualizadas</th>
                                <th className="text-end">% Actualizadas</th>
                            </tr>
                        </thead>
                        <tbody className="fs-7">
                            {rows.length === 0 ? (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted py-10">
                                        No hay datos para los filtros seleccionados.
                                    </td>
                                </tr>
                            ) : (
                                rows.map((row) => (
                                    <tr key={`${row.office_name}-${row.adviser_id}`}>
                                        <td>{row.office_name}</td>
                                        <td>{row.adviser_name}</td>
                                        <td className="text-end">{row.total_policies}</td>
                                        <td className="text-end">{row.assigned_policies}</td>
                                        <td className="text-end">{row.updated_policies}</td>
                                        <td className="text-end">{Number(row.updated_percent).toFixed(2)}%</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
        </Row>
    )
}

SecomReports.layout = (page) => <Layout title="SECOM — Reportes">{page}</Layout>

export default SecomReports
